export const pendingCardStatusOptions = [
  { label: 'Pendente', value: 'pending' },
  { label: 'Aguardando aprovação', value: 'awaiting_approval' },
  { label: 'Impresso', value: 'printed' },
  { label: 'Validado', value: 'validated' },
]
